import { promotileTypes } from '../types/promotileTypes';
import { promotileService } from '../../services/promotileService'; 
import { toast } from 'react-toastify';

export const promoTileAction = { 
    getAll,
    add,
    edit,
    update,
}

function getAll() {
    return dispatch => {
        dispatch({type:promotileTypes.GETALL_PROMOTILE_REQUEST}); 
        promotileService.getAll().then(res => {
            if (res.status) {
                dispatch({type:promotileTypes.GETALL_PROMOTILE_SUCCESS, data: res.data });
                //toast.success(res.message);
            } else {
                dispatch({type:promotileTypes.GETALL_PROMOTILE_ERROR}); 
                toast.error(res.message);
            }
        })

    }
}
function add(data, setErrors, setSubmitting, navigate){
    return dispatch => {
        dispatch({type:promotileTypes.ADD_PROMOTILE_REQUEST});
        promotileService.add(data).then(res => {
            if(res.status){
               dispatch({type:promotileTypes.ADD_PROMOTILE_SUCCESS, data});
               toast.success(res.message);
               setSubmitting(false);
               setTimeout(function () {
                    dispatch(promoTileAction.getAll());
                }, 500);
               //navigate(-1);
            }else{
                dispatch({type:promotileTypes.ADD_PROMOTILE_ERROR, error:res.error});
                toast.error(res.message);
                setSubmitting(false);
                if(res.error) {
                    setErrors(res.error);
                }
            }
        })
    }
}


function update(code, data, setErrors, setSubmitting, navigate){    
    return dispatch => {
        dispatch({type:promotileTypes.UPDATE_PROMOTILE_REQUEST});
        promotileService.update(code,  data).then(res => {
            if(res.status){
                dispatch({type:promotileTypes.UPDATE_PROMOTILE_SUCCESS, data:res.data});
                toast.success(res.message);
                setSubmitting(false);
                navigate("/promotile/view/"+code);
            }else{ 
                dispatch({type:promotileTypes.UPDATE_PROMOTILE_ERROR, error:res.error});
                toast.error(res.message);
                setSubmitting(false);
                if(res.error) {
                    setErrors(res.error);
                    setSubmitting(false);
                }
            }
        })
    }
}

function edit(id){
    return dispatch => {
        dispatch({type:promotileTypes.EDIT_PROMOTILE_REQUEST});
        promotileService.edit(id).then(res => {
            if(res.status){
                dispatch({type:promotileTypes.EDIT_PROMOTILE_SUCCESS, data:res.data})
            }else{
                dispatch({type:promotileTypes.EDIT_PROMOTILE_ERROR, error:res.error});
                toast.error(res.message);
            }
        })
    }
}
